import { Checkbox, Label } from '@heroui/react'
import { useNavigate, useRouterState } from '@tanstack/react-router'
import { Baby, CigaretteOff, DoorOpen } from 'lucide-react'
import { useTranslations } from 'use-intl'
import { clearDiscoverySelection } from '../../lib/filter-state'

interface FilterItem {
  key: 'nonSmoking' | 'hasPrivateRoom' | 'kidsAllowed'
  Icon: React.ComponentType<{ className?: string }>
  labelKey: string
}

const FILTERS: FilterItem[] = [
  { key: 'nonSmoking', Icon: CigaretteOff, labelKey: 'nonSmoking' },
  { key: 'hasPrivateRoom', Icon: DoorOpen, labelKey: 'privateRoom' },
  { key: 'kidsAllowed', Icon: Baby, labelKey: 'kidsAllowed' },
]

export function AdvancedFilters() {
  const navigate = useNavigate()
  const searchParams = useRouterState({ select: (s) => s.location.search })
  const t = useTranslations('discovery')

  const toggleFilter = (key: string, value: boolean) => {
    navigate({
      search: (prev: any) => ({
        ...clearDiscoverySelection(prev),
        [key]: value ? true : undefined,
      }),
      replace: true,
    } as any)
  }

  return (
    <div className="flex items-center gap-4 flex-wrap">
      {FILTERS.map((filter) => {
        const isActive = !!(searchParams as any)[filter.key]
        return (
          <Checkbox
            key={filter.key}
            isSelected={isActive}
            onChange={(val) => toggleFilter(filter.key, Boolean(val))}
            className="group min-h-11 flex-row items-center gap-2 cursor-pointer"
          >
            <Checkbox.Control className="size-4 rounded" />
            <Checkbox.Content>
              <Label className="text-xs font-medium cursor-pointer flex items-center gap-1.5 text-stone-600 dark:text-stone-300 group-hover:text-primary transition-colors">
                <filter.Icon className="w-3.5 h-3.5" />
                {t(filter.labelKey as any, { defaultValue: filter.labelKey })}
              </Label>
            </Checkbox.Content>
          </Checkbox>
        )
      })}
    </div>
  )
}
